import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import { Location } from '@angular/common';

/**
 * This guard is not really a guard. It is used to make TinyMCE TOC anchors scroll into view. If not done this
 * way the Angular router will try and navigate to the anchor route.
 */
@Injectable()
export class MceTocActivateGuard implements CanActivate {
  constructor(private location: Location, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    document.getElementById(route.url?.[0]?.path)?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    return false;
  }
}
